// NATIVE REVIEW REQUIRED: these Tamil strings must be reviewed by a Tamil speaker (ideally from
// the retailer's staff) before go-live. Keep every key — `ta` must satisfy `Strings`, so a
// missing translation is a compile error rather than a silent English fallback.
import type { Strings } from "@frontend/strings/strings.types";

export const ta: Strings = {
	login: {
		title: "மீண்டும் வரவேற்கிறோம்",
		subtitle: "உங்கள் நிர்வாகி கொடுத்த பயனர்பெயருடன் உள்நுழையவும்.",
		heroTitle: "வாங்கும் முன்பே அணிந்து பாருங்கள்.",
		heroBody: (appName) =>
			`வாடிக்கையாளரின் ஒரு புகைப்படமும் ஆடையின் ஒரு புகைப்படமும் போதும் — ${appName} ஒரு நிமிடத்திற்குள் புதிய தோற்றத்தை உருவாக்கும்.`,
		username: "பயனர்பெயர்",
		password: "கடவுச்சொல்",
		submit: "உள்நுழை",
		continueWithGoogle: "Google மூலம் தொடரவும்",
		connecting: "இணைக்கிறது…",
		terms: "தொடர்வதன் மூலம், எங்கள் சேவை விதிமுறைகளையும் தனியுரிமைக் கொள்கையையும் ஏற்கிறீர்கள்",
		errorOauthFailed: "அங்கீகாரம் தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
		errorStateMismatch: "அமர்வு காலாவதியானது. மீண்டும் உள்நுழைய முயற்சிக்கவும்.",
		errorCallback: "உள்நுழைவில் பிழை. மீண்டும் முயற்சிக்கவும்.",
		errorGeneric: (message) => `பிழை ஏற்பட்டது: ${message}`,
		failed: "பயனர்பெயர் அல்லது கடவுச்சொல் தவறு",
		deactivated: "இந்த உள்நுழைவு நிறுத்தப்பட்டுள்ளது. உங்கள் நிர்வாகியைத் தொடர்பு கொள்ளவும்.",
		tooManyAttempts: "பல முயற்சிகள். சில வினாடிகள் காத்திருந்து மீண்டும் முயற்சிக்கவும்.",
		serverUnreachable: "இப்போது சர்வரை அடைய முடியவில்லை. இணைப்பைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.",
		signingIn: "உள்நுழைகிறது…",
	},
	nav: {
		customers: "வாடிக்கையாளர்கள்",
		dashboard: "டாஷ்போர்டு",
		users: "பயனர்கள்",
		settings: "அமைப்புகள்",
		profile: "சுயவிவரம்",
		signOut: "வெளியேறு",
	},
	roles: {
		admin: "நிர்வாகி",
		member: "உறுப்பினர்",
		adminHelp: "அனைவரின் தரவையும் பார்க்கலாம், பயனர்களையும் அமைப்புகளையும் நிர்வகிக்கலாம்",
		memberHelp: "தங்கள் வாடிக்கையாளர்களையும் தோற்றங்களையும் மட்டும் பார்க்கலாம்",
	},
	studio: {
		phone: "தொலைபேசி எண்",
		phoneHelp: "WhatsApp-க்குத் தேவை; பின்னர் சேர்க்கலாம்",
		name: "பெயர்",
		walkInCustomer: "நேரடி வாடிக்கையாளர்",
		looksCount: (n) => `${n} தோற்றங்கள்`,
		newCustomer: "புதிய வாடிக்கையாளர்",
		editCustomer: "வாடிக்கையாளரைத் திருத்து",
		phoneTaken: "இந்த எண் ஏற்கனவே வேறொரு வாடிக்கையாளருடையது.",
		useExisting: "அந்த வாடிக்கையாளரைப் பயன்படுத்து",
		garmentType: "ஆடை வகை",
		garmentTypeRememberFailed: "இந்த ஆடை வகையை உங்கள் லாகினுக்கு நினைவில் வைக்க முடியவில்லை",
		quality: "தரம்",
		standard: "ஸ்டாண்டர்ட்",
		premium: "பிரீமியம்",
		noImagesLeft: (tier) => `${tier} படங்கள் தீர்ந்துவிட்டன — உங்கள் நிர்வாகியைக் கேளுங்கள்`,
		customerPhoto: "வாடிக்கையாளர் புகைப்படம்",
		customerPhotoHint: "கேமராவை நேராகப் பார்க்கவும், நல்ல வெளிச்சம், தலை முதல் இடுப்பு வரை",
		garmentPhoto: (noun) => `${noun} புகைப்படம்`,
		garmentPhotoHint: "முழு வடிவமைப்பும் தெரியும்படி விரிக்கவும் அல்லது தொங்கவிடவும்",
		takePhoto: "புகைப்படம் எடு",
		stepOf: (n, total) => `படி ${n} / ${total}`,
		gallery: "கேலரி",
		noCreditsTitle: "படங்கள் எதுவும் இல்லை",
		noCreditsHelp: "ஸ்டாண்டர்ட் மற்றும் பிரீமியம் தொகுப்புகள் தீர்ந்துவிட்டன. ட்ரை-ஆன் தொடங்கும் முன் உங்கள் நிர்வாகியிடம் நிரப்பச் சொல்லுங்கள்.",
		uploadFromGallery: "அல்லது கேலரியிலிருந்து பதிவேற்று",
		flip: "திருப்பு",
		switchCamera: "கேமராவை மாற்று",
		closeCamera: "தோற்றத்திற்குத் திரும்பு",
		cameraUnavailable: "இங்கே கேமரா இல்லை. கேமரா ஆப்பில் புகைப்படம் எடுக்கவும் அல்லது கேலரியிலிருந்து தேர்வு செய்யவும்.",
		cameraDenied: "கேமரா அனுமதி தடுக்கப்பட்டுள்ளது. உலாவி அமைப்புகளில் அனுமதிக்கவும், அல்லது புகைப்படத்தைத் தேர்வு செய்யவும்.",
		saving: "சேமிக்கிறது…",
		backToCustomers: "வாடிக்கையாளர்களுக்குத் திரும்பு",
		addDetails: "தொலைபேசி & பெயர் சேர்",
		fromGallery: "கேலரியிலிருந்து",
		photoError: "இந்தப் புகைப்படத்தைப் பயன்படுத்த முடியவில்லை. JPEG அல்லது PNG முயற்சிக்கவும், அல்லது மீண்டும் எடுக்கவும்.",
		uploading: "பதிவேற்றுகிறது…",
		uploadFailedRetry: "தோல்வி — மீண்டும் முயற்சிக்கத் தட்டவும்",
		changeCustomerPhoto: "வாடிக்கையாளர் புகைப்படத்தை மாற்று",
		addBothPhotos: (noun) => `வாடிக்கையாளர் மற்றும் ${noun} புகைப்படங்களைச் சேர்க்கவும்`,
		addCustomerPhoto: "இப்போது வாடிக்கையாளரின் புகைப்படத்தைச் சேர்க்கவும்",
		addGarmentPhoto: (noun) => `இப்போது ${noun} புகைப்படத்தைச் சேர்க்கவும்`,
		waitingForUpload: "பதிவேற்றம் முடிகிறது…",
		autoStartHelp: "இரண்டு புகைப்படங்களும் வந்தவுடன் தோற்றம் தானாகவே தொடங்கும்.",
		outOfImages: "இந்தத் தரத்திற்குப் படங்கள் இல்லை. தரத்தை மாற்றவும் அல்லது நிர்வாகியைக் கேளுங்கள்.",
		startFailed: "தோற்றத்தைத் தொடங்க முடியவில்லை.",
		starting: "தொடங்குகிறது…",
		creating: "தோற்றம் உருவாகிறது…",
		timeLeft: (seconds) => `சுமார் ${seconds} வி மீதம்`,
		almostThere: "கிட்டத்தட்ட முடிந்தது…",
		lookFailed: "இந்தத் தோற்றத்தை உருவாக்க முடியவில்லை.",
		tryAgain: "மீண்டும் முயற்சி",
		lookN: (n) => `தோற்றம் ${n}`,
		allLooks: (n) => `தோற்றங்கள் · ${n}`,
		newLook: "புதிய தோற்றம்",
		tryAnother: (noun) => `வேறொரு ${noun}`,
		makePremium: "பிரீமியமாக்கு",
		regenerate: "மீண்டும் உருவாக்கு",
		regenerateConfirm: "இது தோற்றத்தை மீண்டும் உருவாக்கும்; உங்கள் பேக்கிலிருந்து இன்னொரு படத்தைப் பயன்படுத்தும்.",
		whatToChange: "என்ன மாற வேண்டும்? (விருப்பம்)",
		whatToChangeExample: "எ.கா. அதிக வெளிச்சம், முந்தானை இடது தோளில்",
		useOneImage: "1 படத்தைப் பயன்படுத்து",
		shareImage: "படத்தைப் பகிர்",
		shareFailed: (message) => `பகிர முடியவில்லை: ${message}`,
		savedToShare: (n) => `${n} படங்கள் சேமிக்கப்பட்டன — WhatsApp-இல் இணைக்கவும்.`,
		select: "தேர்ந்தெடு",
		pickedCount: (n) => (n === 0 ? "பகிர தோற்றங்களைத் தேர்ந்தெடுக்கவும்" : `${n} தேர்ந்தெடுக்கப்பட்டன`),
		shareN: (n) => (n <= 1 ? "பகிர்" : `${n} படங்களைப் பகிர்`),
	},
	customers: {
		search: "எண் அல்லது பெயரால் தேடு",
		none: "இன்னும் வாடிக்கையாளர்கள் இல்லை",
		noMatch: "பொருந்தும் வாடிக்கையாளர்கள் இல்லை",
		noneHelp: "ஸ்டுடியோவில் ஒரு ட்ரை-ஆனைத் தொடங்குங்கள்; வாடிக்கையாளர் இங்கே தோன்றுவார்.",
		more: "மேலும்",
		delete: "வாடிக்கையாளர் தரவை நீக்கு",
		deleteConfirm:
			"இது வாடிக்கையாளர், அவரது புகைப்படங்கள் மற்றும் அனைத்து தோற்றங்களையும் நிரந்தரமாக நீக்கும். திரும்பப் பெற முடியாது.",
		deleteAction: "நீக்கு",
		deleted: "வாடிக்கையாளர் தரவு நீக்கப்பட்டது",
	},
	dashboard: {
		title: "டாஷ்போர்டு",
		subtitleAdmin: "முழுக் கடையின் செயல்பாடு.",
		subtitleMember: "உங்கள் ட்ரை-ஆன்கள் ஒரே பார்வையில்.",
		period: "காலம்",
		today: "இன்று",
		days: (n) => `${n} நாட்கள்`,
		export: "ஏற்றுமதி",
		exportLooks: "தோற்றங்கள் (CSV)",
		exportSummary: "சுருக்கம் (CSV)",
		exportTruncated:
			"சமீபத்திய 10,000 தோற்றங்கள் மட்டுமே ஏற்றுமதி செய்யப்பட்டன. மீதமுள்ளவற்றுக்கு காலத்தைக் குறைக்கவும்.",
		person: "நபர்",
		everyone: "அனைவரும்",
		looks: "தோற்றங்கள்",
		looksN: (n) => `${n} தோற்றங்கள்`,
		shared: "பகிரப்பட்டவை",
		ofReady: (pct) => `முடிந்த தோற்றங்களில் ${pct}%`,
		customers: "வாடிக்கையாளர்கள்",
		successRate: "வெற்றி விகிதம்",
		failedN: (n) => `${n} தோல்வி`,
		looksPerDay: "நாள்தோறும் தோற்றங்கள்",
		topPeople: "முன்னணி நபர்கள்",
		noLooks: "இந்தக் காலத்தில் தோற்றங்கள் இல்லை",
		credits: "மீதமுள்ள படங்கள்",
		creditsUnavailable: "இப்போது பட இருப்பை ஏற்ற முடியவில்லை.",
		imagesLeftLabel: (tier) => `மீதமுள்ள ${tier} படங்கள்`,
		packUsage: (usedPct, expires) => `${usedPct}% பயன்படுத்தப்பட்டது · காலாவதி ${expires}`,
		noPacks: "செயலில் உள்ள பேக் இல்லை",
		topUpContact: "கூடுதல் படங்களுக்கு உங்கள் சேவை வழங்குநரை (Tezi Communications) தொடர்பு கொள்ளவும்.",
		recentLooks: "சமீபத்திய தோற்றங்கள்",
		quality: "தரம்",
		status: "நிலை",
		allQualities: "அனைத்து தரங்களும்",
		allStatuses: "அனைத்து நிலைகளும்",
		statusLabel: { queued: "வரிசையில்", processing: "உருவாகிறது", ready: "தயார்", failed: "தோல்வி" },
		loadMore: "மேலும் காட்டு",
	},
	admin: {
		products: "தயாரிப்புகள்",
		productsHelp: "ஸ்டுடியோ வழங்கும் தயாரிப்பு வகைகள். பிராண்ட் (பெயர், லோகோ, ஐகான், நிறங்கள்) உங்கள் வழங்குநரால் அமைக்கப்படுகிறது.",
		instructions: "கூடுதல் வழிமுறைகள்",
		instructionsHelp: "ஒவ்வொரு தோற்றத்திற்கும் உள்ளமைந்த வழிமுறையுடன் சேர்க்கப்படும், எ.கா. \"முந்தானையை இடது தோளில் வைக்கவும்\". தேவையில்லை என்றால் காலியாக விடவும்.",
		usersTitle: "பயனர்கள்",
		usersSubtitle:
			"நிர்வாகிகள் அனைத்தையும் பார்க்கலாம். உறுப்பினர்கள் தங்கள் வாடிக்கையாளர்களையும் தோற்றங்களையும் மட்டும் பார்க்கலாம்.",
		newUser: "புதிய பயனர்",
		you: "நீங்கள்",
		actions: "செயல்கள்",
		saved: "சேமிக்கப்பட்டது",
		done: "முடிந்தது",
		create: "உருவாக்கு",
		actionFailed: (message) => `சேமிக்க முடியவில்லை: ${message}`,
		name: "பெயர்",
		username: "பயனர்பெயர்",
		usernameHelp: "சிறிய ஆங்கில எழுத்துகள், எண்கள், _ மற்றும் . மட்டும்",
		password: "கடவுச்சொல்",
		generate: "உருவாக்கு",
		showPassword: "கடவுச்சொல்லைக் காட்டு",
		hidePassword: "கடவுச்சொல்லை மறை",
		role: "பங்கு",
		language: "மொழி",
		active: "செயலில்",
		switchedOff: "நிறுத்தப்பட்டது",
		looks30d: "தோற்றங்கள் (30 நாட்கள்)",
		lastLook: "கடைசி தோற்றம்",
		resetPassword: "கடவுச்சொல்லை மாற்று",
		makeAdmin: "நிர்வாகியாக்கு",
		makeMember: "உறுப்பினராக்கு",
		switchOff: "நிறுத்து",
		switchOn: "மீண்டும் இயக்கு",
		changeLanguageTo: (language) => `மொழி: ${language}`,
		shareCredentials: "இந்த உள்நுழைவு விவரங்களைப் பகிரவும்",
		shareCredentialsHelp: "கடவுச்சொல் ஒருமுறை மட்டுமே காட்டப்படும். இப்போதே நகலெடுக்கவும்.",
		copy: "நகலெடு",
		copied: "நகலெடுக்கப்பட்டது",
		credentialsText: (appName, username, password) =>
			`${appName} உள்நுழைவு
பயனர்பெயர்: ${username}
கடவுச்சொல்: ${password}`,
		settingsTitle: "அமைப்புகள்",
		settingsSubtitle: "உங்கள் பிராண்ட், வாட்டர்மார்க் மற்றும் ட்ரை-ஆன் விருப்பங்கள்.",
		unsavedChanges: "சேமிக்காத மாற்றங்கள்",
		discard: "நிராகரி",
		logoUrl: "லோகோ URL",
		garmentNouns: "ஆடை வகைகள்",
		garmentNounsHelp:
			"ஆங்கிலத்தில், எ.கா. saree. முதலாவது இயல்புநிலை. ஒன்றுக்கு மேல் இருந்தால் ஸ்டுடியோவில் தேர்வு காட்டப்படும்; ஒவ்வொரு லாகினும் கடைசியாகத் தேர்ந்தெடுத்த வகையை எல்லா வாடிக்கையாளர்களுக்கும் நினைவில் வைத்திருக்கும்.",
		garmentNounPlaceholder: "எ.கா. lehenga",
		addGarmentNoun: "சேர்",
		makeDefault: "இயல்புநிலை ஆக்கு",
		defaultGarment: "இயல்புநிலை",
		removeGarmentNoun: "நீக்கு",
		watermark: "வாட்டர்மார்க்",
		watermarkHelp: "பகிரப்படும் ஒவ்வொரு படத்திலும் உங்கள் லோகோ.",
		watermarkEnabled: "ஒவ்வொரு தோற்றத்திலும் லோகோவைச் சேர்",
		watermarkLogoHelp: "பிராண்ட் லோகோவைப் பயன்படுத்த காலியாக விடவும்",
		position: "இடம்",
		topLeft: "மேல் இடது",
		topRight: "மேல் வலது",
		bottomLeft: "கீழ் இடது",
		bottomRight: "கீழ் வலது",
		scale: "அளவு",
		opacity: "ஒளிபுகா தன்மை",
		margin: "ஓரம் (px)",
		preview: "முன்னோட்டம்",
		tryonOptions: "ட்ரை-ஆன்",
		tryonOptionsHelp: "படத்தின் வடிவம் மற்றும் ஒவ்வொரு தோற்றத்திற்குமான கூடுதல் வழிமுறைகள்.",
		aspect: "படத்தின் வடிவம்",
	},
	offline: {
		title: "இணைய இணைப்பு இல்லை",
		body: "இணையம் திரும்பும் வரை புகைப்படங்களைப் பதிவேற்றவோ தோற்றங்களை உருவாக்கவோ முடியாது.",
		retry: "மீண்டும் முயற்சி",
		checking: "சரிபார்க்கிறது…",
		backOnline: "இணையம் மீண்டும் கிடைத்தது",
		studioHint: "இணைப்பு இல்லை — புகைப்படங்களைச் சேர்க்க மீண்டும் இணையுங்கள்.",
	},
	profile: {
		title: "சுயவிவரம்",
		appearance: "தோற்றப் பாணி",
		appearanceHelp: "ஒளி, இருண்ட அல்லது இந்தச் சாதனத்தைப் பின்பற்று.",
		light: "ஒளி",
		dark: "இருண்ட",
		system: "சாதனம்",
		language: "மொழி",
		languageSaved: "மொழி மாற்றப்பட்டது",
		camera: "கேமரா",
		cameraHelp: "ஸ்டுடியோ முதலில் திறக்கும் கேமரா. எந்தப் படத்துக்கும் மாற்றிக்கொள்ளலாம்.",
		cameraBack: "பின்புறம்",
		cameraFront: "முன்புறம்",
		cameraSaved: "கேமரா மாற்றப்பட்டது",
		cameraSaveFailed: "கேமரா அமைப்பைச் சேமிக்க முடியவில்லை",
	},
	pwa: {
		installTitle: (appName) => `${appName} செயலியை நிறுவவும்`,
		installBody: (appName) => `சிறந்த அனுபவத்திற்கு ${appName} செயலியை உங்கள் முகப்புத் திரையில் சேர்க்கவும்.`,
	},
	common: {
		language: "மொழி",
		english: "English",
		tamil: "தமிழ்",
		loading: "ஏற்றுகிறது…",
		retry: "மீண்டும் முயற்சி",
		refresh: "புதுப்பி",
		close: "மூடு",
		cancel: "ரத்து செய்",
		save: "சேமி",
	},
};
